export default "__VITE_ASSET__DHbVkQZq__"